import { getTypeofGarments } from "controllers/TypeOfGarments";
import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";

// const country = localStorage.getItem('country');


async function dataStream(callback) {
  // const typeofgarment = [{id:1,label:'Denim',value:"Denim"},{id:2,label:'Sportswear',value:"Sportswear"},{id:3,label:'Bodysuit',value:"Bodysuit"}]
  const typeofgarment = await getTypeofGarments();
  callback(sortArrayPipe.transform(typeofgarment, 'value'));
}
const TypeofgarmentSelect = withBaseSelect([], dataStream);
export default TypeofgarmentSelect;
